module.exports = __webpack_public_path__ + "static/media/EHS-Gifts-and-Legacies-Policy.857c60eb.pdf";